import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';

let CompactionControlSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Compaction Control Results">
        <Field input={<TextOutput />} name="Results.DryDensityRatio" emph />
        <Field input={<TextOutput />} name="Results.MoistureRatio" emph />
        <Field input={<TextOutput />} name="Results.MoistureVariation" emph />
        <Field input={<TextOutput />} name="Results.SoilMoistureLevel" emph />
      </ListFieldSection>
    </>
  );
};

CompactionControlSection = withInjectedProps(CompactionControlSection);

export { CompactionControlSection };
export default CompactionControlSection;
